- const { parent, season, team } = properties

.prices
  .player.header(class=season.sport)
    .shirt.sortable(
      (click)=parent.sortBy('shirt'),
      class={ sorted: parent.sort === 'shirt' },
      )
      | #
      ft-icon(name=parent.categoryIcon('shirt', parent.sort, parent.reverse))
    .name.sortable(
      class={sorted: !parent.sort || parent.sort === 'name'},
      (click)=parent.sortBy('name')
      )
      | Name
      ft-icon(name=parent.categoryIcon('name', parent.sort, parent.reverse))
    if season?.isDuel
      .position Pos
    each action in parent.PLAYER_ACTIONS
      .player-action= action.replace(/_/g, ' ')

  ft-pagination(
    current=parent.pages[team] || 0,
    size=50,
    total=parent.filteredPlayers(team).length,
    display=5,
    border,
    (currentChanged)=parent.changePage(team, e.current)
  )

  each player, j in parent.sortedPlayers(team)
    .player(class={odd: j % 2, id: player._id, [season.sport]: true})
      .shirt
        if player.shirt || player.shirt === 0
          = player.shirt
      .short-name(title=player.fullName)= player.name
      if season?.isDuel || parent.season.league.sport === 'eurovision'
        .position  (#{player.pos})
      each action in parent.PLAYER_ACTIONS
        .player-action
          sporty-form-field([(value)]=player.actionPoints[action])
            input(
              type="number",
            )

